import {
    Component,
    ElementRef,
    HostListener,
    OnInit,
    ViewChild,
} from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    FormControl,
    Validators,
    ValidatorFn,
    AbstractControl,
    ValidationErrors,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-add-call-alert-form',
    templateUrl: './add-call-alert-form.component.html',
    styleUrls: ['./add-call-alert-form.component.scss'],
})
export class AddCallAlertFormComponent implements OnInit {
    callAlertForm: FormGroup;
    usersData: any;
    userId: any;
    currentUser: any;
    callAlertTypes: any[] = [];
    showDateTimePicker = false;
    callFromList: any[] = [];
    activationStatusList: any[] = [];

    @ViewChild('datetimeWrapper', { static: false })
    datetimeWrapper: ElementRef;

    constructor(
        private service: GeneralService,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<AddCallAlertFormComponent>
    ) {}

    ngOnInit() {
        this.currentUser = this.service.getcurrentUser();
        this.getCallAlertType();

        this.callAlertForm = this.fb.group({
            call_alert_type_id: new FormControl(null, Validators.required),
            call_initiated_from: [null, Validators.required],
            purpose: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
            call_type: new FormControl(null, Validators.required),
            activation_status: new FormControl(null, Validators.required),
            // reference_source: new FormControl(null),
            priority: new FormControl(null, Validators.required),
            follow_up_date: new FormControl(new Date(), [
                // ✅ Set current date & time
                Validators.required,
                this.futureDateValidator(),
            ]),
            call_remarks: new FormControl(null, [Validators.required, Validators.maxLength(1000)]),
        });
        this.getCallFromList();
        this.getActivationStatusList();
    }

    trimValuePurpose(controlName: string) {
        const control = this.callAlertForm.get(controlName);
        if (control && control.value) {
            control.setValue(control.value.trim());
        }
    }

    getCallFromList() {
        this.service.getCallInitiatedFrom().subscribe(
            (res: any) => {
                if (res) {
                    this.callFromList = res.data;
                }
            },
            (error) => {
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            },
        );
    }

    getActivationStatusList() {
        this.service.getActivationStatus().subscribe(
            (res: any) => {
                if (res) {
                    this.activationStatusList = res.data;
                }
            },
            (error) => {
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            },
        );
    }

    close() {
        this.dialogRef.close(false);
    }

    customSearchFn(term: string, item: any): boolean {
        if (!term) return true;
        return item.alert_type.toLowerCase().startsWith(term.toLowerCase());
    }

    futureDateValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) return null;

            const selectedDate = new Date(control.value);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);

            return selectedDate < currentDate ? { pastDate: true } : null;
        };
    }

    getCallAlertType() {
        this.service.getCallAlertType().subscribe(
            (res: any) => {
                if (res) {
                    this.callAlertTypes = res.data;
                }
            },
            (error) => {
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
            }
        );
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (
            this.showDateTimePicker &&
            this.datetimeWrapper &&
            !this.datetimeWrapper.nativeElement.contains(event.target)
        ) {
            this.showDateTimePicker = false;
        }
    }

    onDateTimeSelected(selectedDate: Date) {
        this.callAlertForm.get('follow_up_date').setValue(selectedDate);
        this.callAlertForm.get('follow_up_date').markAsTouched();
        this.showDateTimePicker = false;
    }

    isLoading = false;

    submit() {
        if (this.callAlertForm.invalid) {
            this.callAlertForm.markAllAsTouched();
            return;
        }

        if (this.isLoading) return;
        this.isLoading = true;

        const fullDate: Date = this.callAlertForm.get('follow_up_date').value;

        const day = fullDate.getDate().toString().padStart(2, '0');
        const month = (fullDate.getMonth() + 1).toString().padStart(2, '0');
        const year = fullDate.getFullYear();

        const hours = fullDate.getHours().toString().padStart(2, '0');
        const minutes = fullDate.getMinutes().toString().padStart(2, '0');

        const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

        const obj = {
            follow_up_date: formattedDateTime,
            user_id: this.userId,
            called_by_csr: this.currentUser.Id,
        };
        const temp = Object.assign(this.callAlertForm.value, obj);

        this.service.addCallAlert(temp).subscribe(
            (res: any) => {
                this.isLoading = false;
                if (res.status === 200) {
                    Swal.fire({
                        title: 'Call Alert Added',
                        text: res.message,
                        type: 'success',
                        timer: 1500,
                        showConfirmButton: false,
                    });
                    this.callAlertForm.reset();
                    this.dialogRef.close(true);
                }
            },
            (error) => {
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                });
                this.dialogRef.close(false);
            }
        );
    }

    trimValue(key: string) {
        const control = this.callAlertForm.controls[key];
        if (control.value && typeof control.value === 'string') {
            control.setValue(control.value.trim());
        }
    }
}
